export const EXPRESSION_TABS = {
  VARIABLES: "variables",
  SCHEMA: "schema",
  SAMPLE_DATA: "sample-data"
};

export const EXPRESSION_DIALOG_STRINGS = {
  TITLE: "Custom Expression",
  APPLY_CHANGES: "Apply changes",
  EXPRESSION_EDITOR_TITLE: "Expression Editor",
  EXPRESSION_EDITOR_SUBTITLE: "Write and test your JavaScript expression below.",
  OUTPUT_TITLE: "Output",
  EXPECTED_OUTPUT_TYPE: "Expected output type",
  UNIQUE_NAME_REQUIRED: "Unique name is required.",
  UNIQUE_NAME_DUPLICATE: "Unique name must be unique.",
  UNIQUE_NAME_INVALID: "Use letters, digits or _ (no spaces, can't start with a digit).",
  UNIQUE_NAME_RESERVED: "Unique name cannot be a JavaScript reserved word.",
  UNIQUE_NAME_PLACEHOLDER: "Enter unique name",
  VARIABLES_IN_USE_TITLE: "Variables in use in this expression",
  AVAILABLE_TO_ADD_TITLE: "Available to add",
  AVAILABLE_TO_ADD_SUBTITLE: "Give each variable a unique name (applies to this expression only).",
  NO_VARIABLES_TITLE: "No variables available",
  NO_VARIABLES_SUBTITLE: "No variables are configured for this agent.",
  NO_ADDED_VARIABLES_TITLE: "No variables added yet",
  NO_ADDED_VARIABLES_SUBTITLE: "Add variables below to use them in your expression.",
  ALL_VARIABLES_ADDED_TITLE: "All variables added",
  ALL_VARIABLES_ADDED_SUBTITLE: "You've added all available variables.",
  NO_SCHEMA_TITLE: "No schema to display",
  NO_SCHEMA_SUBTITLE: "Define variables in the Variables tab to view their schema information here",
  NO_SAMPLE_DATA_TITLE: "No sample data to display",
  NO_SAMPLE_DATA_SUBTITLE: "Define variables in the Variables tab to view their sample data here",
  GO_TO_VARIABLES: "Go to variables",
  EDIT_MODE_TOOLTIP: "Enter edit mode to make changes",
  EXPRESSION_TAG_TOOLTIP: "This field is using a custom expression. Selecting \"Revert to default\" will remove the expression and restore plain text.",
  UNEXPECTED_ERROR: "An unexpected error occurred. Please try again.",
  UNEXPECTED_ERROR_THROWN: "Unexpected error occurred while testing expression",
  NO_CHANGES: "No changes have been made",
  TEST_FAILED: "Expression test failed",
  TEST_BEFORE_APPLYING: "Test expression before applying",
  TEST_NO_VARIABLES: "Add at least one variable before testing.",
  VARIABLE_SCHEMA_TITLE: "Variable schema",
  OUTPUT_SCHEMA_TITLE: "Output schema",
  VARIABLE_SCHEMA_INPUT_SUBTITLE: "JSON schema for the variables added to this expression.",
  VARIABLE_SCHEMA_OUTPUT_SUBTITLE: "JSON schema for the expected output of this expression."
};

export const SCHEMA_MODES = {
  INPUT: "Input",
  OUTPUT: "Output"
};

export const MAX_EXPRESSION_LENGTH = 500;

export const VALID_UNIQUE_NAME_PATTERN = /^[A-Za-z_]\w*$/;

export const RESERVED_UNIQUE_NAMES = new Set([
  "break", "case", "catch", "class", "const", "continue", "debugger", "default",
  "delete", "do", "else", "export", "extends", "finally", "for", "function",
  "if", "import", "in", "instanceof", "new", "return", "super", "switch",
  "this", "throw", "try", "typeof", "var", "void", "while", "with", "yield",
  "let", "static", "implements", "interface", "package", "private", "protected",
  "public", "enum",
  "null", "true", "false",
  "undefined", "NaN", "Infinity"
]);
